import { pick } from 'lodash';
import { StyleSheet } from 'react-native';
import { useSelector } from 'react-redux';

import { appInfoSelector } from '@common/redux/selectors/app';
import { AppVersion } from 'click-types';
import { IWebView } from '@common/types/element';

const createStyles = (attributes: IWebView) => {
  const appInfo = useSelector(appInfoSelector);
  const isV4 = appInfo?.version === AppVersion.V4;
  const style = attributes.style || {};

  return StyleSheet.create({
    container: {
      ...pick(attributes, [
        'marginTop',
        'marginLeft',
        'width',
        'height',
        'zIndex',
      ]),
      ...(isV4 &&
        pick(style, [
          'top',
          'left',
          'bottom',
          'right',
          'position',
          'transform',
          'margin',
          'marginTop',
          'marginLeft',
          'marginBottom',
          'marginRight',
        ])),
    },
    errorRender: {
      width: '100%',
      height: '100%',
      backgroundColor: 'white',
      justifyContent: 'center',
      alignItems: 'center',
    },
  });
};

export default createStyles;
